import { makeApiCall } from '../../../_common/api.utils';
import { FIN_API_URL } from '../../../const';

/** ***************** GET OPENING BALANCE DETAILS START *********************** */
export const openingBalanceDetailsGet = (addData: any) => {
	const data = {
		OpeningBalanceListToken: addData,
	};
	const url = `${FIN_API_URL}getOpeningBalanceDetails`;
	return makeApiCall(url, data);
};
/** ***************** GET OPENING BALANCE DETAILS END *********************** */

/** ***************** UPDATE OPENING BALANCE DETAILS START *********************** */
export const openingBalanceDetailsUpdate = (addData: any) => {
	const data = {
		UpdateOpeningBalanceDataToken: addData,
	};
	const url = `${FIN_API_URL}updateOpeningBalanceDetails`;
	return makeApiCall(url, data);
};
/** ***************** UPDATE OPENING BALANCE DETAILS END *********************** */
